import classNames from "classnames";
import { Alert } from "../Icon/Icon";
import styles from "./Banner.module.scss";

function Banner({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <Alert size="medium" />
      {typeof children === "string" ? <span>{children}</span> : children}
    </div>
  );
}

export default Banner;
